import type { IDataAccessor } from "@core/data-access";
import { AbstractAccessorService } from "@core/data-access";
import type { IUserDataProxy, IUserPreference } from "./user-data-proxy";
import { IResponse } from "@core/data-access/model";
import { UserPreferences } from "@modules/basic/page/page-object-tree";

export class UserDataProxy extends AbstractAccessorService<IUserPreference> implements IUserDataProxy {

    public readonly $name = "userDataProxy";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<IUserPreference>) {
        super();
    }

    updateUserPreferences(userPreferences: UserPreferences): angular.IPromise<IResponse<boolean>> {
        return this.$accessor<boolean, {}, string>(this.$name, "updateUserPreferences", {
            data: userPreferences
        });
    }
}